export const SEARCH_LIMIT = 24
